<template>
  <v-alert
    v-if="!validDate && orderDate"
    prominent
    type="error"
    class="ma-0 px-4 py-2"
    outlined
    text
  >
    <v-row align="center" justify="center">
      <v-col cols="12" md="8"
        >Your {{ orderDateLabel }} of
        <b>{{ computedDateFormattedMomentjs }}</b> invalid</v-col
      >
      <v-col cols="12" md="4" style="text-align: end">
        <v-btn
          outlined
          color="error"
          :to="
            isStandingOrder
              ? { name: 'StandingOrderCreate' }
              : { name: 'OrdersCreate' }
          "
          >Change Date</v-btn
        >
      </v-col>
    </v-row>
  </v-alert>
  <v-alert
    v-else-if="validDate && orderDate"
    prominent
    type="info"
    class="ma-0 px-4 py-2"
    outlined
    text
  >
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <span v-if="collection">This is a collection order </span>
        <span v-else>This is a delivery order </span>
        <span v-if="isStandingOrder">starting </span>
        <span v-else>for </span>
        <b>{{ computedDateFormattedMomentjs }}</b>
      </v-col>
      <v-col cols="12" md="4" style="text-align: end">
        <v-btn
          outlined
          color="blue darken-2"
          exact
          :to="
            isStandingOrder
              ? { name: 'StandingOrderCreate' }
              : { name: 'OrdersCreate' }
          "
          class="ml-4"
          >Change Date</v-btn
        >
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import moment from "moment";

export default {
  props: {
    isStandingOrder: Boolean,
  },
  computed: {
    collection() {
      return this.$store.getters.retrieveIsCncCustomer;
    },

    orderDateLabel() {
      let label = "delivery date";

      if (this.$store.getters.retrieveIsCncCustomer) {
        label = "collection date";
      }

      if (this.isStandingOrder) {
        label = "standing order start date";
      }

      return label;
    },

    computedDateFormattedMomentjs() {
      if (this.isStandingOrder) {
        return this.$store.getters.retrieveStandingOrderTrolly.order_date
          ? moment(
              this.$store.getters.retrieveStandingOrderTrolly.order_date
            ).format("dddd, Do MMMM YYYY")
          : "";
      } else {
        return this.$store.getters.retrieveCurrentTrolly.order_date
          ? moment(this.$store.getters.retrieveCurrentTrolly.order_date).format(
              "dddd, Do MMMM YYYY"
            )
          : "";
      }
    },

    orderDate() {
      if (this.isStandingOrder) {
        if (!this.$store.getters.retrieveStandingOrderTrolly) {
          return false;
        } else {
          return this.$store.getters.retrieveStandingOrderTrolly
            .order_date_display;
        }
      } else {
        if (!this.$store.getters.retrieveCurrentTrolly) {
          return false;
        } else {
          return this.$store.getters.retrieveCurrentTrolly.order_date_display;
        }
      }
    },

    validDate() {
      if (this.isStandingOrder) {
        if (this.$store.getters.retrieveStandingOrderTrolly) {
          return this.$store.getters.retrieveStandingOrderTrolly
            .delivery_date_valid.valid;
        }
        return true;
      } else {
        if (this.$store.getters.retrieveCurrentTrolly) {
          return this.$store.getters.retrieveCurrentTrolly.delivery_date_valid
            .valid;
        }
        return true;
      }
    },

    dateInfo() {
      return this.$store.getters.retrieveCurrentTrolly;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>